import React from "react";
import { useQuery } from "react-query";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import ApiService from "../../services/ApiService";
import PageTitle from "@cs/components/src/PageTitle";
import { PageWrapperTwoColumn } from "@cs/components/src/PageWrapper";
import Spinner from "@cs/components/src/Spinner";
import RunScriptForm from "./RunScriptForm";
import { JobViewParams } from "../jobs/JobView";
import Select from "@cs/components/src/Select";

const SelectWrapper = styled.div`
  max-width: 400px;
  width: 50vw;
  margin-left: 20px;
`;

const RunScriptListScreen = () => {
  const { scriptId } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, isError } = useQuery({
    queryFn: async () => {
      const response = await ApiService.fetch<{ data: ScriptConfigItem[] }>(
        "GET",
        `/api/config/script`
      );
      return response.data;
    },
  });

  return (
    <>
      <PageTitle
        title="Scripts"
        titleChildren={
          <SelectWrapper>
            <Select
              value={scriptId ?? null}
              options={
                data?.map((script) => ({
                  value: script.id,
                  label: script.title,
                })) ?? []
              }
              onChange={({ value }) => {
                navigate(`../script/${value}`);
              }}
              placeholder="Choose a script..."
            />
          </SelectWrapper>
        }
        error={isError ? "Error loading scripts" : undefined}
      ></PageTitle>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <PageWrapperTwoColumn>
            <RunScriptForm />
            <Routes>
              <Route
                path=":systemDomainId/:instanceId/:jobId"
                element={<JobViewParams />}
              />
            </Routes>
          </PageWrapperTwoColumn>
        </>
      )}
    </>
  );
};

export default RunScriptListScreen;
